import { api } from '@/lib/api';
import type {
  IApiResponse,
  ICreateTeamRequest,
  ITeam,
  IUpdateTeamRequest,
} from '@skystone/shared';

export const teamApi = {
  getAll: async (options?: { includeArchived?: boolean; productId?: string }): Promise<ITeam[]> => {
    const params = new URLSearchParams();
    if (options?.includeArchived === true) params.set('includeArchived', 'true');
    if (options?.productId !== undefined) params.set('productId', options.productId);
    const query = params.toString();
    const paramsString = query === '' ? '' : `?${query}`;
    const result = await api.get<IApiResponse<ITeam[]>>(`/teams${paramsString}`);
    return result.data;
  },

  getById: async (id: string): Promise<ITeam> => {
    const result = await api.get<IApiResponse<ITeam>>(`/teams/${id}`);
    return result.data;
  },

  /** PRODOPSAI-540: create a manual team (admin only). 409 ConflictError on
   *  `team_key` collision is surfaced to the caller for inline field display. */
  create: async (body: ICreateTeamRequest): Promise<ITeam> => {
    const result = await api.post<IApiResponse<ITeam>>(`/admin/teams`, body);
    return result.data;
  },

  /** PRODOPSAI-540: update a manual team. The backend rejects edits on
   *  `fabric_synced=true` rows with 400 TEAM_IS_FABRIC_SYNCED. */
  update: async (id: string, body: IUpdateTeamRequest): Promise<ITeam> => {
    const result = await api.patch<IApiResponse<ITeam>>(`/admin/teams/${id}`, body);
    return result.data;
  },

  /** PRODOPSAI-540/617: soft-archive a team (manual or Fabric-synced).
   *  Memberships are preserved. A manual archive is sticky — the Fabric sync
   *  will not re-activate the team. */
  delete: async (id: string): Promise<ITeam> => {
    const result = await api.delete<IApiResponse<ITeam>>(`/admin/teams/${id}`);
    return result.data;
  },

  /** PRODOPSAI-617: re-activate an archived team (manual or Fabric-synced). */
  reactivate: async (id: string): Promise<ITeam> => {
    const result = await api.post<IApiResponse<ITeam>>(`/admin/teams/${id}/reactivate`);
    return result.data;
  },
};
